/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 3/20/13
 * Time: 10:46 AM
 * Layout view used as the main view for the connection main page
 */
define(function (require) {
    "use strict";

    var CONST = require("const");
    var LE = require("app");
    var template = require("connection-templates/connectionMain.tmpl");
    var ChatInvitationItemView = require("connection-views/ChatInvitationItemView");

    require("jqueryui/draggable");
    var Modernizr = require('modernizr');

    var ConnectionMainLayout = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ConnectionMainLayout = Marionette.Layout.extend({
            className: 'connection-bar-main',
            template: template,
            oldSwitchClassTop: [],
            regions: {
                connectionProfile: '.connection-profile',
                connectionSideBar: '.connection-side-bar',
                connectionChat: '.connection-chat',
                connectionExpand: '.connection-expand',
                connectionSurvey: '.connection-survey-wrapper',
                connectionChatInvitation: '.connection-chat-invitation'
            },
            ui: {
                connectionLoader: ".connection-loader-wrapper",
                connectionLayoutFrame: ".connection-layout-frame",
                connectionLayout: ".connection-layout",
                connectionLayoutAnchor: ".connection-layout-anchor",
                connectionLayoutWrapper: ".connection-layout-wrapper"
            },
            events: {
                "click .connection-layout-anchor": "onAnchorClicked"
            },
            initialize: function (options) {
                this.onAnchorClicked = $.proxy(function () {
                    this.hideChatInvitation();
                    options.onAnchorClicked();
                }, this);
            },
            onRender: function () {
                var self = this;
                this.visible = true;
//                this.ui.connectionLayoutFrame.load(function () {
                setTimeout(function () {
                    self.trigger("frameReady", self.ui.connectionLayoutFrame);
                }, 0);
//                });
                this.model.on("change:connection:loading", this.onLoadingChanged, this);
                this.ui.connectionLayoutWrapper.draggable({
                    axis: "y",
                    containment: ".work-area-wrapper"
                });

                $(document).mousemove(function (e) {
                    if (self.ui.connectionLayoutWrapper.hasClass("timedHide")) {
                        if (!self.visible && (window.outerWidth - e.clientX < 20)) {
                            self.visible = true;
                        } else if (self.visible && (window.outerWidth - e.clientX > 20)) {
                            self.visible = false;
                        }
                    }
                    else {
                        self.visible = false;
                    }

                    self.ui.connectionLayoutWrapper.toggleClass("open", self.visible);
                    //LE.context.set(CONST.MODULES.CONNECTION + ".isOpened", self.visible);
                });
                if (!LE.sessionManager.getAccountId()) {
                    this.chatInvitationItemView = new ChatInvitationItemView({model: this.model, onclick: this.onAnchorClicked});
                    this.connectionChatInvitation.show(this.chatInvitationItemView);
                }
            },
            hideChatInvitation: function () {
                if (this.chatInvitationItemView && this.chatInvitationItemView.$el) {
                    this.chatInvitationItemView.$el.hide();
                }
            },
            toggleIframe: function (toggle) {
                this.ui.connectionLayout.toggle(toggle);
            },
            onLoadingChanged: function (data, loading) {
                this.ui.connectionLoader.toggle(loading);
            },
            overrideTimeHide: function (isTimedHide) {
                this.ui.connectionLayoutWrapper.toggleClass("override", this.timedHide && !isTimedHide);
            },
            setFrameSwitchClass: function (connectionState) {
                var that = this;
                var controlSwitchClass = connectionState.switchClass.substr(0, connectionState.switchClass.indexOf(" "));
                controlSwitchClass = controlSwitchClass ? controlSwitchClass : connectionState.switchClass;
                if (this.oldSwitchClass) {
                    this.oldSwitchClassTop[this.oldSwitchClass] = this.ui.connectionLayoutWrapper.css("top");
                    this.ui.connectionLayoutWrapper.css("top", "");
                    this.ui.connectionLayoutWrapper.removeClass(this.oldClasses);
                    this.ui.connectionLayoutWrapper.removeClass("open");
                    this.ui.connectionLayoutWrapper.removeClass("override");
                }
                if (this.oldSwitchClassTop[controlSwitchClass]) {
                    this.ui.connectionLayoutWrapper.css("top", this.oldSwitchClassTop[controlSwitchClass]);
                }
                var animationClass = connectionState.animationClass && !this.isAnimation && Modernizr.cssanimations ? " " + connectionState.animationClass : "";

                if (animationClass) {
                    this.isAnimation = true;
                    var animEndEventName = this.animEndEventNames[ Modernizr.prefixed('animation') ];
                    var transitionEndEventName = this.transitionEndEventNames[ Modernizr.prefixed('transition') ];
                    var endFunc = function () {
                        that.ui.connectionLayoutWrapper.off(animEndEventName);
                        that.ui.connectionLayoutWrapper.off(transitionEndEventName);
                        that.ui.connectionLayoutWrapper.removeClass(animationClass);
                        that.timedHide = connectionState.timedHide;
                        that.ui.connectionLayoutWrapper.toggleClass("timedHide", connectionState.timedHide);
                        that.isAnimation = false;
                    };
                    that.ui.connectionLayoutWrapper.on(animEndEventName, endFunc);
                    that.ui.connectionLayoutWrapper.on(transitionEndEventName, endFunc);
                }
                this.ui.connectionLayoutWrapper.addClass(connectionState.switchClass + animationClass);
                that.ui.connectionLayoutAnchor.css("z-index", connectionState.useAnchor ? "2001" : "1999");
                this.oldSwitchClass = controlSwitchClass;
                this.oldClasses = connectionState.switchClass;

                var isOpen=connectionState.switchClass!=="connection-layout-minimized";
                LE.context.set(CONST.MODULES.CONNECTION + ".isOpened", isOpen);
            },
            animEndEventNames: {
                'WebkitAnimation': 'webkitAnimationEnd',
                'OAnimation': 'oAnimationEnd',
                'msAnimation': 'MSAnimationEnd',
                'animation': 'animationend'
            },
            transitionEndEventNames: {
                'WebkitTransition': 'webkitTransitionEnd',
                'OTransition': 'oTransitionEnd',
                'msTransition': 'MSTransitionEnd',
                'transition': 'transitionend'
            }
        });
    });
    return ConnectionMainLayout;
});
